import Logo from '../../../assets/icon/something-wrong.svg';

const ErrorIcon = () => {
  return <img src={Logo} alt="Error icon"/>;
};

export default ErrorIcon;
